import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelectFieldWithAddRemoveComponent from './../component';
import * as _ from 'lodash';

class SelectFieldWithAddRemove extends Component {
  onAddClick = () => {
    let { value } = this.props.input;
    value = value.concat([{ key: null, WarehouseSiteId: null, text: ' ' }]);
    this.props.input.onChange(value);
  };
  onDeleteClick = index => {
    let { value } = this.props.input;
    value = [...value];
    value.splice(index, 1);
    this.props.input.onChange(value);
  };
  onMoveItemUp = index => {
    let itemUpCloneItems = Object.assign([], this.props.input.value);
    const currentItemToMoveUp = itemUpCloneItems[index];
    itemUpCloneItems.splice(index, 1);
    itemUpCloneItems.splice(index - 1, 0, currentItemToMoveUp);
    this.props.input.onChange(itemUpCloneItems);
  };
  onMoveItemDown = index => {
    let itemDownCloneItems = Object.assign([], this.props.input.value);
    const currentItemToMoveDown = itemDownCloneItems[index];
    itemDownCloneItems.splice(index, 1);
    itemDownCloneItems.splice(index + 1, 0, currentItemToMoveDown);
    this.props.input.onChange(itemDownCloneItems);
  };
  onChange = (index, event, data) => {
    let { value } = this.props.input;
    if (!value) {
      value = [];
    }

    const existingValue = value[index];

    let selectedData = {
      key: data.value,
      WarehouseSiteId: data.value,
      text: '',
    };
    if (existingValue) {
      selectedData = Object.assign({}, existingValue, selectedData);
    }
    if (data) {
      const { options, value } = data;
      const selectedOption = _.filter(options, obj => {
        return obj.value === value;
      });
      if (selectedOption.length > 0) {
        selectedData.text = selectedOption[0].text;
      }
    }

    value = Object.assign([], value, { [index]: selectedData });
    this.props.input.onChange(value);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      const { input, dataSource } = this.props;
      const modifiedValues = [];
      if (input.value && input.value.length > 0) {
        _.each(input.value, item => {
          if (!item.text) {
            const selectedOption = _.filter(dataSource, obj => {
              return obj.value === item.WarehouseSiteId;
            });
            if (selectedOption.length > 0) {
              const newItem = Object.assign({}, item, {
                text: selectedOption[0].text,
              });
              modifiedValues.push(newItem);
            }
          } else {
            modifiedValues.push(item);
          }
        });
      } else {
        modifiedValues.push({ key: null, WarehouseSiteId: null, text: ' ' });
      }
      this.props.input.onChange(modifiedValues);
    }
  }

  render() {
    const { input, dataSource, primaryId, ...rest } = this.props;
    const items =
      input.value && input.value.length > 0
        ? input.value
        : [{ key: null, WarehouseSiteId: null, text: ' ' }];
    return (
      <SelectFieldWithAddRemoveComponent
        items={items}
        dataSource={dataSource}
        defaultValue={primaryId}
        onChange={this.onChange}
        onAddClick={this.onAddClick}
        onDeleteClick={this.onDeleteClick}
        onMoveItemUp={this.onMoveItemUp}
        onMoveItemDown={this.onMoveItemDown}
        {...rest}
      />
    );
  }
}
const mapStateToProps = ({ SelectFieldWithAddRemoveState }) => {
  return {};
};
export const SelectFieldWithAddRemoveContainer = connect(mapStateToProps)(
  SelectFieldWithAddRemove
);



// WEBPACK FOOTER //
// ./src/components/selectFieldWithAddRemove/container/index.js